import theme from "../../Theme";

export const renderBlackLegend = (value: string, entry: any) => {
	return <span style={{ color: theme.palette.text.primary }}>{value}</span>;
};